// extracted by mini-css-extract-plugin
export default {"modal":"j_huJ","modal-background":"zYAfG","title":"ww3AD","description":"oHlH6","button-container":"HB1YH","close":"DEKgD"};